/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetProject } from 'src/app/pmo-pages/pmo/shared-modules/project-details/project-details-routing.module';
import { Subscription } from 'rxjs';
import { Project, ReportHeaderVm } from 'src/app/core/backend/pm/models';
import { ProjectDailyReportsService } from 'src/app/core/backend/pm/services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'header-print'!,
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header-print.component.html',
  styleUrls: ['./header-print.component.scss'],
})
export class HeaderPrintComponent implements OnInit {
  @Input() No: any = 'لايوجد';
  @Input() date: string | undefined = '';
  @Input() consultant: boolean = false;
  project: Project | undefined;
  projectHeader: ReportHeaderVm | undefined;
  domain = environment.api;

  subscription = new Subscription();
  readonly #getProjectService = inject(GetProject);
  readonly #getProjectHeader = inject(ProjectDailyReportsService);
  ngOnInit(): void {
    this.#getProjectDetails();
    this.#getHeader();
  }
  #getProjectDetails() {
    this.subscription.add(
      this.#getProjectService.projectFullResponse.subscribe((res) => {
        this.project = res?.project;
      }),
    );
  }
  #getHeader() {
    this.subscription.add(
      this.#getProjectHeader
        .apiProjectDailyTaskReportsGetReportHeaderGet({
          ProjectId: this.project?.id,
        })
        .subscribe((res) => {
          this.projectHeader = res.reportHeader;
        }),
    );
  }
}
